import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancellationStatisticsComponent } from './cancellation-statistics.component';
import { IonicModule } from '@ionic/angular';
import { TranslationModule } from '@app/app-translation.module';
import { StatisticFilterComponentModule } from '@internal-components/statistic-components/statistic-filter-component/statistic-filter.component.module';
import { CancellationsOnAgeCategoriesStatisticComponentModule } from '../cancellations-on-age-categories-statistic-component/cancellations-on-age-categories-statistic.component.module';
import { CancellationsCountStatisticComponentModule } from '../cancellations-count-statistic-component/cancellations-count-statistic.component.module';
import { CancellationsOnReasonsStatisticComponentModule } from '../cancellations-on-reasons-statistic-component/cancellations-on-reasons-statistic.component.module';
import { CancellationsOnTargetAudiencesStatisticComponentModule } from '../cancellations-on-target-audiences-statistic-component copy/cancellations-on-target-audiences-statistic.component.module';
import { CancellationsOnAgenciesStatisticComponentModule } from '../cancellations-on-agencies-statistic-component/cancellations-on-agencies-statistic.component.module';
import { CancellationsOnAttendanceTypesStatisticComponentModule } from '../cancellations-on-attendance-types-statistic-component/cancellations-on-attendance-types-statistic.component.module';
import { CancellationsOnDigibankObjectivesStatisticComponentModule } from '../cancellations-on-digibank-objectives-statistic-component/cancellations-on-digibank-objectives-statistic.component.module';
import { CancellationsOnEventTypesStatisticComponentModule } from '../cancellations-on-event-types-statistic-component/cancellations-on-event-types-statistic.component.module';
import { CancellationsOnGendersStatisticComponentModule } from '../cancellations-on-genders-statistic-component/cancellations-on-genders-statistic.component.module';
import { CancellationsOnLocationsStatisticComponentModule } from '../cancellations-on-locations-statistic-component/cancellations-on-locations-statistic.component.module';
import { CancellationsOnOriginsStatisticComponentModule } from '../cancellations-on-origins-statistic-component/cancellations-on-origins-statistic.component.module';
import { CancellationsOnZipcodesStatisticComponentModule } from '../cancellations-on-zipcodes-statistic-component/cancellations-on-zipcodes-statistic.component.module';

@NgModule({
	declarations: [CancellationStatisticsComponent],
	exports: [CancellationStatisticsComponent],
	imports: [
		CommonModule,
		IonicModule,
		TranslationModule,
		StatisticFilterComponentModule,
		CancellationsCountStatisticComponentModule,
		CancellationsOnReasonsStatisticComponentModule,
		CancellationsOnTargetAudiencesStatisticComponentModule,
		CancellationsOnAgeCategoriesStatisticComponentModule,
		CancellationsOnAgenciesStatisticComponentModule,
		CancellationsOnAttendanceTypesStatisticComponentModule,
		CancellationsOnDigibankObjectivesStatisticComponentModule,
		CancellationsOnEventTypesStatisticComponentModule,
		CancellationsOnGendersStatisticComponentModule,
		CancellationsOnLocationsStatisticComponentModule,
		CancellationsOnOriginsStatisticComponentModule,
		CancellationsOnZipcodesStatisticComponentModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CancellationStatisticsComponentModule {}
